import { createSlice } from '@reduxjs/toolkit'
import api from '../../Core/Services/Api'
import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { manageMapEpicResponse } from '../../Common/Utils/Api'
import { apiMapSlice } from '../../Common/Utils/Redux'

const emptyData = []

// reducer
const signalLoggerSignalsSlice = createSlice(apiMapSlice('signalLoggerSignals'))

export const { request, success, failure } = signalLoggerSignalsSlice.actions

export default signalLoggerSignalsSlice.reducer

export const selectSignalLoggerSignals = (state) => state.signalLoggerSignals
export const selectSignalLoggerSignalsData = id => (state) => state.signalLoggerSignals.data[id]?.value || emptyData
export const selectSignalLoggerSignalsFetching = id => (state) => state.signalLoggerSignals.fetching[id]
export const selectSignalLoggerSignalsFetched = id => (state) => state.signalLoggerSignals.fetched[id]

// side effects
export const fetchSignalLoggerSignalsEpic = (action$) =>
  action$.pipe(
    ofType('signalLoggerSignals/request'),
    mergeMap((action) => {
      const { id, configurationId } = action.payload
      return from(
        api.signalLoggerConfigurations.getSignals(id, configurationId),
      ).pipe(
        ...manageMapEpicResponse(
          id, // the map id
          success,
          failure,
          'configurator:errors.FetchSignalLoggerSignalsError',
        ),
      )
    }),
  )
